import React, {useContext, useEffect, useMemo, useState} from "react"
import Cookies from "js-cookie"

import {TOKEN_NAME} from "@backend/types/base"
import {LoggedUserType} from "@backend/types/paging"
import {getParameterByName} from "@utils/helpers"
import AuthService from "@auth/service"

export interface AuthContextType {
    loaded: boolean;
    user: LoggedUserType;
    isAdmin: boolean,
    logout: () => void;
}

let AuthContext = React.createContext<AuthContextType>(null!)

export function useAuth(): AuthContextType {
    return useContext(AuthContext)
}

export function AuthProvider({children}: { children: React.ReactNode }) {
    const [user, setUser] = useState<LoggedUserType>()
    const [loaded, setLoaded] = useState<boolean>(false)

    useEffect(() => {
        if (!loaded) {
            if (!user) {
                const tempToken = getParameterByName("access_token", window.location.href)
                const token = Cookies.get(TOKEN_NAME)
                if (token || tempToken) {
                    AuthService
                        .loginWithToken({token, tempToken})
                        .then((result) => {
                            Cookies.set(TOKEN_NAME, result.token)
                            setUser(result)
                        })
                        .finally(() => {
                            setLoaded(true)
                        })
                } else {
                    setLoaded(true)
                }
            }
        }
    }, [])

    const login = (managerData: LoggedUserType) => {
        const {token, ...userData} = managerData
        Cookies.set(TOKEN_NAME, token)
        setUser(userData)
        setLoaded(true)
    }


    const logout = () => {
        Cookies.remove(TOKEN_NAME)
        setUser(null)
    }

    const memoedValue = useMemo(
        () => ({
            loaded,
            user,
            isAdmin: user?.isAdmin,
            login,
            logout
        }),
        [loaded, user]
    )

    return <AuthContext.Provider value={memoedValue}>
        {!loaded ? <div>loading...</div> : children}
    </AuthContext.Provider>
}